module.exports = __webpack_public_path__ + "media/images/front/icon_memo-39b51808a390f1c09a083bbd4abba021.png";